export class ApiError extends Error {
  constructor({ error, message, details }) {
    super(message);
    this.name = "ApiError";
    this.error = error;
    this.details = details;
  }
}